<template>
  <div class="steps">
    <div class="row u-justify-content-center">
      <div class="col-12 col-md-8 col-lg-10">
          <h1 class="u-text-align-center">{{ $t('system.select') }}</h1>
      </div>
      <div class="row u-justify-content-center">
        <div class="col-12 col-md-8 col-lg-4 u-display-flex">
          <StepOptions
            :img="classic_img"
            :text="$t('system.classic.description', {icon: classic_icon})"
            :label="$t('system.classic.label')"
            @click="openClassic"
          ></StepOptions>
        </div>
        <!--
        <div class="col-12 col-md-8 col-lg-4 u-display-flex" v-if="$store.getters.coldroom != 'LT'">
          <StepOptions
            :img="view_img"
            :text="$t('system.view.description', {icon: view_icon})"
            :label="$t('system.view.label')"
            @click="openView"
          ></StepOptions>
        </div>
        -->
        <div class="col-12 col-md-8 col-lg-4 u-display-flex" v-if="$store.getters.coldroom != 'LT'">
          <StepOptions
            :img="tview_img"
            :text="$t('system.t_view.description', {icon: tview_icon})"
            :label="$t('system.t_view.label')"
            @click="openViewT"
          ></StepOptions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepOptions from "./StepOptions";
import classic from "../assets/images/system_classic.jpg"
import view from "../assets/images/system_view.jpg"
import TView from "../assets/images/system_t_view.jpg"
import TrackingHelper from "../helpers/TrackingHelper";

export default {
  name: "SecondStep",
  props: [
    'openClassic',
    'openView',
    'openViewT'
  ],
  components: {
    StepOptions,
  },
  mounted () {
    window.trackDownload = this.trackDownload;
  },
  computed: {
    classic_img () {
      return '<div class="card__img"><img src="' + classic + '" /></div>';
    },
    view_img () {
      return '<div class="card__img"><img src="' + view + '" /></div>';
    },
    tview_img () {
      return '<div class="card__img"><img src="' + TView + '" /></div>';
    },
    classic_icon () {
      return '<span><a target="_blank" onClick="trackDownload(\'classic datasheet download\', \'https://media.schott.com/api/public/content/52afc6112fd24138bcfb66fd4b56dfd0\')" href="https://media.schott.com/api/public/content/52afc6112fd24138bcfb66fd4b56dfd0?v=e88ea108"><i class="icon-pdf"></i></a></span>'
    },
    view_icon () {
      return '<span><a target="_blank" onClick="trackDownload(\'view datasheet download\', \'https://media.schott.com/api/public/content/8905f9a68c4747ef9005bfddd3d21a39\')" href="https://media.schott.com/api/public/content/8905f9a68c4747ef9005bfddd3d21a39?v=e2a1b56c"><i class="icon-pdf"></i></a></span>'
    },
    tview_icon () {
      return '<span><a target="_blank" onClick="trackDownload(\'t.view datasheet download\', \'https://media.schott.com/api/public/content/8905f9a68c4747ef9005bfddd3d21a39\')" href="https://media.schott.com/api/public/content/8905f9a68c4747ef9005bfddd3d21a39?v=e2a1b56c"><i class="icon-pdf"></i></a></span>'
    }
  },
  methods: {
    trackDownload(name, url) {
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.downloadTracking(name, url);
    },
  },
}
</script>
